// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var TextField = require("@mui/material/TextField").default;
var MM_cmp_pe_frame_summary = require("./MM_cmp_pe_frame_summary.res.js");
var Pagination = require("@mui/material/Pagination").default;

var nonDigitPattern = /\D/g;

function propsAreSame(a, b) {
  if (a.typeColors === b.typeColors && a.editStmtsByLeftClick === b.editStmtsByLeftClick && a.settings === b.settings && a.preCtx === b.preCtx && a.symColors === b.symColors && a.labels === b.labels && a.highlightMatchedSymbols === b.highlightMatchedSymbols && a.highlightColor === b.highlightColor) {
    return a.asrtsPerPage === b.asrtsPerPage;
  } else {
    return false;
  }
}

var make = React.memo((function (param) {
        var addAsrtByLabel = param.addAsrtByLabel;
        var asrtsPerPage = param.asrtsPerPage;
        var openExplorer = param.openExplorer;
        var openFrameExplorer = param.openFrameExplorer;
        var highlightColor = param.highlightColor;
        var highlightMatchedSymbols = param.highlightMatchedSymbols;
        var labels = param.labels;
        var typeOrderInDisj = param.typeOrderInDisj;
        var syntaxTypes = param.syntaxTypes;
        var parenCnt = param.parenCnt;
        var frms = param.frms;
        var symColors = param.symColors;
        var preCtx = param.preCtx;
        var settings = param.settings;
        var editStmtsByLeftClick = param.editStmtsByLeftClick;
        var typeColors = param.typeColors;
        var modalRef = param.modalRef;
        var match = React.useState(function () {
              return 0;
            });
        var setPageIdx = match[1];
        var pageIdx = match[0];
        var match$1 = React.useState(function () {
              return "";
            });
        var setGoToPageText = match$1[1];
        var goToPageText = match$1[0];
        var pageSize = Math.max(1, Math.min(asrtsPerPage, 100));
        var numOfPages = Math.ceil(labels.length / pageSize) | 0;
        var beginIdx = Math.imul(pageIdx, pageSize);
        var endIdx = (beginIdx + pageSize | 0) - 1 | 0;
        var actReset = function () {
          setPageIdx(function (param) {
                return 0;
              });
          setGoToPageText(function (param) {
                return "";
              });
        };
        React.useEffect((function () {
                actReset();
              }), [
              labels,
              asrtsPerPage
            ]);
        var actChangePage = function (newPageNum) {
          if (1 <= newPageNum && newPageNum <= numOfPages) {
            setPageIdx(function (param) {
                  return newPageNum - 1 | 0;
                });
            setGoToPageText(function (param) {
                  return "";
                });
            return window.scrollTo(0, 0);
          }
          
        };
        var actGoToPage = function () {
          var newPageNum = Belt_Int.fromString(goToPageText);
          if (newPageNum !== undefined) {
            return actChangePage(newPageNum);
          }
          
        };
        var rndPagination = function () {
          return React.createElement(Expln_React_Row.make, {
                      alignItems: "center",
                      children: Caml_option.some(null)
                    }, React.createElement(Pagination, {
                          count: numOfPages,
                          page: pageIdx + 1 | 0,
                          onChange: (function (param, newPage) {
                              actChangePage(newPage);
                            })
                        }), React.createElement(TextField, {
                          value: goToPageText,
                          label: "Go to page",
                          size: "small",
                          style: {
                            width: "150px"
                          },
                          onChange: Expln_React_common.evt2str(function (newPage) {
                                setGoToPageText(function (param) {
                                      return newPage.replace(nonDigitPattern, "");
                                    });
                              }),
                          onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actGoToPage)
                        }));
        };
        var rndFrames = function () {
          if (labels.length === 0) {
            return "No assertions match the search criteria.";
          } else {
            return React.createElement(Expln_React_Column.make, {
                        spacing: 2,
                        children: Caml_option.some(null)
                      }, rndPagination(), labels.slice(beginIdx, endIdx + 1 | 0).map(function (label) {
                            var label$1 = label[0];
                            var frame = MM_context.getFrame(preCtx, label$1);
                            if (frame === undefined) {
                              return null;
                            }
                            var order = frame.ord + 1 | 0;
                            return JsxPPXReactSupportU.createElementWithKey(String(order) + "-" + label$1, MM_cmp_pe_frame_summary.make, {
                                        modalRef: modalRef,
                                        typeColors: typeColors,
                                        editStmtsByLeftClick: editStmtsByLeftClick,
                                        typeOrderInDisj: typeOrderInDisj,
                                        settings: settings,
                                        preCtx: preCtx,
                                        symColors: symColors,
                                        syntaxTypes: syntaxTypes,
                                        frms: frms,
                                        parenCnt: parenCnt,
                                        frame: frame,
                                        order: order,
                                        matchedIdxs: highlightMatchedSymbols ? label[1] : undefined,
                                        highlightColor: highlightColor,
                                        openFrameExplorer: openFrameExplorer,
                                        openExplorer: openExplorer,
                                        addAsrtByLabel: addAsrtByLabel
                                      });
                          }), rndPagination());
          }
        };
        return rndFrames();
      }), propsAreSame);

exports.nonDigitPattern = nonDigitPattern;
exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
